import Vue from "vue";
import Vuex from "vuex";
//import router from "../router";
//import firebase from "firebase";
import * as firebase from "firebase/app";
import "firebase/auth";

import { db } from "../main";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    persons: null,
    user: null,
    settings: {},
    saldo: null,
    debug: false,
    snackbar: {},
    error: false,
    profile: null,
    functions: null,
    classes: null
  },
  mutations: {
    snackbarAdd(state, payload) {
      this.state.snackbar = payload;
    },
    fetchUser(state, user) {
      state.user = user;
      //firebase.auth().currentUser.
    },
    fetchActivePersons(state, persons) {
      state.persons = persons;
    },
    setProfile(state, profile) {
      state.profile = profile;
      //firebase.auth().currentUser.
    },
    setFunctions(state, functions) {
      state.functions = functions;
      //firebase.auth().currentUser.
    },
    setClasses(state, classes) {
      state.classes = classes;
      //firebase.auth().currentUser.
    }
  },
  actions: {
    async getUserData(context) {
      // Current user
      let user = firebase.auth().currentUser;

      try {
        if (user) {
          // console.log('getting the data of uid:', user.uid);
          let data = await db
            .collection("profiles")
            .where("uuid", "==", user.uid)

            .get();

          let userData = {
            id: data.docs[0].id,
            ...data.docs[0].data()
          };
          //console.log(userData);
          context.commit("fetchUser", userData);
        } else {
          this.state.user = null;
        }
      } catch (ex) {
        // Handle error
        return;
      }

      // Handle success
      // const data = response.body;
    },
    logout() {
      this.state.user = null;
    },
    async Persons(context) {
      const persons = await db
        .collection("profiles")
        // .where("active", "==", true)
        .orderBy("firstName", "asc")
        .get();

      //console.log(persons);
      let changedPersons = [];
      persons.forEach(person => {
        let data = {
          id: person.id,
          ...person.data()
        };
        //console.log('person', person.data());
        changedPersons.push(data);
      });
      //console.log(changedPersons);
      context.commit("fetchActivePersons", changedPersons);
    },
    async activePersons(context) {
      const persons = await db
        .collection("profiles")
        // .where("active", "==", true)
        .orderBy("firstName", "asc")
        .get();

      //console.log(persons);
      let changedPersons = [];
      persons.forEach(person => {
        let data = {
          id: person.id,
          ...person.data()
        };
        //console.log('person', person.data());
        changedPersons.push(data);
      });
      //console.log(changedPersons);
      context.commit("fetchActivePersons", changedPersons);
    },
    async GET_PROFILE(context, payload) {
      context.commit("setProfile", null);
      // console.log(payload);
      let profile = await db
        .collection("profiles")
        .doc(payload)
        .get();
      //console.log('profile', profile.data());
      let data = {
        id: profile.id,
        ...profile.data()
      };

      context.commit("setProfile", data);
    },
    async GET_CLASSES(context) {
      const classes = await db.collection("hold").get();

      //console.log(persons);
      let classesData = [];
      classes.forEach(newClass => {
        let data = {
          id: newClass.id,
          ...newClass.data()
        };
        //console.log('person', person.data());
        classesData.push(data);
      });
      //console.log(changedPersons);
      context.commit("setClasses", classesData);
    },
    async GET_FUNCTIONS(context) {
      const functions = await db.collection("profilFunktion").get();

      //console.log(persons);
      let functionsData = [];
      functions.forEach(newFunction => {
        let data = {
          id: newFunction.id,
          ...newFunction.data()
        };
        //console.log('person', person.data());
        functionsData.push(data);
      });
      //console.log(changedPersons);
      context.commit("setFunctions", functionsData);
    },
    snackbar({ commit }, payload) {
      commit("snackbarAdd", payload);
    }
  },
  getters: {
    user: state => state.user,
    getList: state => state.persons,
    getSnackbars: state => state.snackbar,
    getFunctions: state => state.functions,
    getClasses: state => state.snackbar,
    profilesByFunction(state) {
      return functionID => {
        //console.log(functionID);
        // value is the function ID
        if (functionID && state.persons) {
          return state.persons.filter(person => {
            //console.log(person);
            return person.function === functionID;
          });
        }
      };
    },
    profilesByClass(state) {
      return ClassID => {
        //console.log(functionID);
        // value is the function ID
        if (ClassID && state.persons) {
          return state.persons.filter(person => {
            //console.log(person);
            return person.class === ClassID;
          });
        }
      };
    },

    fetchProfile(state) {
      return profileId => {
        return state.persons.find(person => {
          return person.id === profileId;
        });
      };
    }
  },
  modules: {}
});
